export const buildMemberDlink = (id: number): string => {
  return `https://dlink.wear.jp/user/${id}/`
}
